import { Application } from "@hotwired/stimulus"
import 'flowbite'
import { Alert } from "tailwindcss-stimulus-components"


const application = Application.start()

application.register("alert", Alert);

import StimulusTomSelect from "stimulus-tom-select";
application.register("tom-select", StimulusTomSelect);

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
